import exp from "constants";
import {
    bank,
    benefitIcon1,
    benefitIcon2,
    benefitIcon3,
    benefitIcon4,
    benefitImage2,
    chromecast,
    disc02,
    equifax,
    experian,
    facebook,
    fastly,
    file02,
    finicity,
    homeSmile,
    instagram,
    notification2,
    notification3,
    notification4,
    plaid,
    plusSquare,
    recording01,
    recording03,
    roadmap1,
    roadmap2,
    roadmap3,
    roadmap4,
    roadmap5,
    roadmap6,
    searchMd,
    sliders04,
    twitter,
    linkedin,
    yourlogo,
  } from "../assets";
  import mockup1 from "../assets/mockup1.png";


  
  export const navigation = [
    {
      id: "0",
      title: "Home",
      url: "#Home",
    },
    {
        id: "1",
        title: "About",
        url: "#About",
      },
    {
      id: "2",
      title: "Credit",
      url: "#Credit",
    },
   
    {
      id: "3",
      title: "Monitoring",
      url: "#Monitoring",
    },
    {
        id: "6",
        title: "Contact",
        url: "#Contact",
    },
    {
      id: "4",
      title: "New account",
      url: "#Signup",
      onlyMobile: true,
    },
    {
      id: "5",
      title: "Sign in",
      url: "#Login",
      onlyMobile: true,
    },
  ];
  
  export const heroIcons = [homeSmile, file02, searchMd, plusSquare];
  
  export const notificationImages = [notification4, notification3, notification2];
  
  export const companyLogos = [yourlogo, yourlogo, yourlogo, yourlogo, yourlogo];
  
  export const brainwaveServices = [
    "Photo generating",
    "Photo enhance",
    "Seamless Integration",
  ];
  
  export const brainwaveServicesIcons = [
    recording03,
    recording01,
    disc02,
    chromecast,
    sliders04,
  ];
  
  export const roadmap = [
    {
      id: "0",
      title: "Integration with Experian",
      text: "Seamless Integration with Experian for Enhanced Credit Insights",
      date: "October 2024",
      status: "progress",
      imageUrl: experian,
      colorful: true,
    },
    {
      id: "1",
      title: "Mobile Application",
      text: "Check your Equifax credit scores, as well as your credit report, directly from our App.",
      date: "November 2024",
      status: "progress",
      imageUrl: mockup1,
    },
    {
      id: "2",
      title: "Web Application",
      text: "Access your Equifax credit scores, along with your full credit report, anytime through our app or website.",
      date: "August 2024",
      status: "done",
      imageUrl: roadmap3,
    },
    {
      id: "3",
      title: "Integration with Equifax ",
      text: "Effortlessly Connected to Equifax for Real-Time Credit Monitoring.",
      date: "August 2024",
      status: "done",
      imageUrl: roadmap4,
    },
    {
      id: "4",
      title: "Integration with Finicity ",
      text: "Effortlessly connected to Finicity for real-time financial data aggregation and insights.",
      date: "August 2024",
      status: "done",
      imageUrl: roadmap5,
    },
    {
      id: "5",
      title: "Integration with Fastly ",
      text: "Seamlessly integrated with Fastly for rapid content delivery and enhanced website performance.",
      date: "August 2024",
      status: "done",
      imageUrl: roadmap6,
    },
   
  ];
  
  export const collabText =
    "";
  
  export const collabContent = [
    {
      id: "0",
     
      text: "At Futeur.ai, we’re not just navigating the future; we’re steering it in your favor. With a name that whispers readiness, we’re your trusty co-pilots in the ever-changing skies of finance. We blend savvy technology with a touch of clairvoyance to ensure your business stays steps ahead, turning uncertainty into opportunity." ,
    },
   
  ];
  
  export const collabApps = [
    
    {
      id: "0",
      title: "Equifax",
      icon: equifax,
      width: 60,
      height: 60,
    },
    {
      id: "1",
      title: "Finicity",
      icon: finicity,
      width: 60,
      height: 60,
    },
    {
      id: "3",
      title: "fastly",
      icon: fastly,
      width: 60,
      height: 60,
    },

  ];
  
  export const pricing = [
    {
      id: "0",
      title: "Monthly",
      description: "Access all the features for $22 per month",
      price: "32",
      features: [
        "Real-Time Updates",
	      "Business Credit Scores",
	      "Scores for Business Loans, Vendor Credit & More",
	      "Credit Reports",
	      "Score and Credit Monitoring",
        "Tradeline Reporting",
        "Easy Dispute Process and Tracking",
       
      ],
    },

    // {
    //   id: "1",
    //   title: "Yearly",
    //   description: "Access all the features for $264 per year",
    //   price: 264,
    //   features: [
    //     "Unlimited Access & Real-Time Updates",
	  //     "Business Credit Scores",
	  //     "Scores for Business Loans, Vendor Credit & More",
	  //     "Credit Reports",
	  //     "Score and Credit Monitoring",
    //     "Futeur Digibank Access",
        
    //     "Easy Dispute Process and Tracking",
        
    //   ],
    // },
  ];
  
  export const benefits = [
    
   
    {
      id: "2",
      title: "Managing business credit shouldn’t be overwhelming or expensive. With FuteurAI, you get all the tools you need to build, monitor, and protect your credit—at a fraction of the cost.",
      
    },
  ];
  
  
  export const socials = [
    {
      id: "1",
      title: "Instagram",
      iconUrl: instagram,
      url: "https://www.instagram.com/futeurai/",
    },
    {
      id: "2",
      title: "Twitter",
      iconUrl: twitter,
      url: "https://x.com/FuteurAI",
    },
   
    {
      id: "3",
      title: "LinkedIn",
      iconUrl: linkedin,
      url: "https://www.linkedin.com/showcase/futeurai/posts/?feedView=all",
    },
  ];